import {createTheme, responsiveFontSizes} from "@mui/material";
import {THEME_CONFIG} from "../config";
import { BorderColor } from "@mui/icons-material";

const {
  gradients,
  borders,
  borderRadius,
  shadows,
  primary,
  secondary,
  accent,
  background,
  mode,
  text,
  buttonText
} = THEME_CONFIG

const pleshDark = responsiveFontSizes(createTheme({
  typography: {
    fontFamily: ['neue-kabel'],
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: background,
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          background: background,
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
    root: {
      '& .MuiOutlinedInput-root': {
        backgroundColor: '#fff', // sfondo bianco
        borderRadius: borderRadius.textField,
        color: '#000', // testo nero
        '& fieldset': {
          borderColor: '#000', // era 'BorderColor' con la B maiuscola - errore!
          borderWidth: '3px',
          borderRadius: borderRadius.textField
        },
        '&:hover fieldset': {
          borderColor: '#000', // mantiene il bordo nero al hover
        },
        '&.Mui-focused fieldset': {
          borderColor: '#000', // mantiene il bordo nero quando è in focus
        },
        '& .MuiOutlinedInput-input': {
        color: '#000', // assicura che il testo sia nero
      },
      '& .MuiInputLabel-root': {
        color: '#999', // label grigio quando non è in focus
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: '#000', // label nero quando è in focus
      }
      }
    }
  }
    },
    MuiButton: {
      variants: [
        {
          props: {variant: 'default'},
          style: {
            minHeight: '50px',
            height: 'fit-content',
            width: '100%',
            fontSize: '18px',
            background: 'linear-gradient(90deg, ' + gradients.default[0] + ' 0%, ' + gradients.default[1] + ')',
            border: borders.default,
            color: buttonText.default,
            borderRadius: borderRadius.default,
            borderWidth: '3px',
            boxShadow: shadows.default,
            fontWeight:'bold',
            '&.Mui-disabled': {
              color: 'rgba(0, 0, 0, 0.25)',
            }
          }
        },
        {
          props: {variant: 'home-question'},
          style: {
            background: 'linear-gradient(90deg, ' + gradients.home_question[0] + ' 0%, ' + gradients.home_question[1] + ')',
            border: borders.home_question,
            color: buttonText.home_question,
            borderRadius: borderRadius.default,
            width: '100%',
            lineHeight: 1,
            minHeight: '40px',
            height: 'fit-content',
            fontSize: '1.2rem',
            fontWeight:800,
            boxShadow: shadows.home_question
          }
        },
      ]
    },
  },
  palette: {
    mode: mode,
    primary: {
      main: primary,
    },
    secondary: {
      main: secondary,
    },
    accent: {
      main: accent,
    },
    text: {
      primary: text,
    },
    background: {
      default: background
    }
  },
}));

export default pleshDark
